import { Component, OnInit } from '@angular/core';
import { DashService } from '../dash.service';
import { liveSearch } from '../dash.operator';
import { Subscription } from 'rxjs';
import { Subject } from 'rxjs';
import { NbSearchService } from '@nebular/theme';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

  custDatas = [];
  searchValue = " ";
  isLoading = false;
  internalOnly = false;
  ownersOnly = false;
  pageNo = 0;
  pageSize = 10;

  removeNonAlphaNumeric(str) {
    return str.replace(/[^a-zA-Z0-9@._%+-]/g, "");
  }

  constructor(public dashService: DashService, private searchService: NbSearchService) {
    this.searchService.onSearchInput()
    .subscribe((data: any) => {
      this.searchValue = data.term;
        let newTerm = this.removeNonAlphaNumeric(data.term);
        console.log(this.searchValue,"new Term:",newTerm);
        this.searchUsers(newTerm)
    })
   }

  ngOnInit(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.searchUsers(this.searchValue);
      this.isLoading = false;
    }, 1500);
  }

  private userQuerySubject = new Subject<string>();

  searchUsers(query: string) {
    console.log("search Users 2: " + query)
    this.searchValue = this.removeNonAlphaNumeric(query);
    this.userQuerySubject.next(this.searchValue+","+this.internalOnly+","+this.ownersOnly+','+this.pageNo+","+this.pageSize);
  }

  showInternalOnly(value: boolean) {
    console.log(value);
    this.internalOnly = value;
    this.userQuerySubject.next(this.searchValue+","+this.internalOnly+","+this.ownersOnly+','+this.pageNo+","+this.pageSize);
  }

  showOwnersOnly(value: boolean) {
    console.log(value);
    this.ownersOnly = value;
    this.userQuerySubject.next(this.searchValue+","+this.internalOnly+","+this.ownersOnly+','+this.pageNo+","+this.pageSize);
  }

  changePage(pageSize, pageNo) {
    console.log(pageSize, pageNo)
    this.pageNo = pageNo
    this.pageSize = pageSize
    this.userQuerySubject.next(this.searchValue+","+this.internalOnly+","+this.ownersOnly+','+this.pageNo+","+this.pageSize);
  }

  refresh() {
    // this.searchValue = " ";
    // this.internalOnly = false;
    // this.ownersOnly = false;
    // this.pageNo = 0;
    // this.pageSize = 10;
    this.userQuerySubject.next(this.searchValue+","+this.internalOnly+","+this.ownersOnly+','+this.pageNo+","+this.pageSize);
  }


  readonly custDatas$ = this.userQuerySubject.pipe(
    liveSearch(query => this.dashService.fetchUsers(query))
  );

}
